<template lang="pug">
  v-app-bar( dense app clippedLeft v-if="!isKioskMode")
    v-app-bar-nav-icon( text @click="toggleAppDrawer" )
       v-icon fas fa-bars
    v-toolbar-title.app-title {{ $t('toolbarPage.appTitle') }}
    v-spacer
    v-toolbar-items
      v-menu(v-model="showMenu" offset-y :close-on-content-click="false")
        template(v-slot:activator="{ on, attrs }")
          v-btn.no-background-hover.text--secondary(
            :class="{'pr-0': !$vuetify.breakpoint.xs, 'pl-2': !$vuetify.breakpoint.xs, 'pl-4': $vuetify.breakpoint.xs}"
            :large="$vuetify.breakpoint.xs"
            :text="!$vuetify.breakpoint.xs"
            :icon="$vuetify.breakpoint.xs"
            v-bind="attrs"
            v-on="on"
            :ripple="false")
            v-icon.d-flex.d-sm-none(medium) fa-user-circle
            v-icon.d-none.d-sm-flex(left) fa-user-circle
            span.d-none.d-sm-flex {{userLoggedIn.fullName}}
        user-drop-down(@closeMenu="closeMenu")
  v-app-bar.pr-0.toolbar-style( dense app v-else)
      v-progress-linear(
        v-if="showLogOutTimer"
        v-model="getProgress"
        color="primary"
        height="8px"
        bottom
        absolute)
      v-row.ma-0.mr-0.text-end(justify="end" )

        v-col.text-start.pt-6(cols="3")
          span {{ $t('loginPage.proxiaLiveLabel') }}
        v-spacer
        //v-col.pt-6(align="center" justify="center" cols="4")
          span.text-center.text-h5(:class="getTimerClass") {{countDown}}
        v-spacer
        v-col.text-end.pt-6(align="end" justify="end" cols="3")
          v-icon.pb-2.pr-2 fa-user-circle
          span.title.pt-12.pb-0 {{userLoggedIn.fullName}}


</template>

<script lang="ts">
import Vue from 'vue'
import {TOGGLE_APP_DRAWER} from '@/store/action-types'
import UserDropDown from '@/components/user/UserDropDown.vue'
import {Component, Prop} from 'vue-property-decorator'
import { CurrentUser } from '@/model/CurrentUser'
import {GET_MODE, GET_SHOW_LOGOUT_TIMER_MODE, USER_LOGGED_IN} from '@/store/getter-types'

@Component({
  components: {
    UserDropDown
  }
})
export default class AppToolbar extends Vue {

  @Prop({type: Number, required: false}) countDown!: number

  private showMenu: boolean = false


  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get showLogOutTimer (): boolean {
    return this.$store.getters[GET_SHOW_LOGOUT_TIMER_MODE]
  }

  get getTimerClass (): string {
    return this.countDown <= 10 ? 'timer' : ''
  }

  get userLoggedIn(): CurrentUser{
    return this.$store.getters[USER_LOGGED_IN]
  }

  get getProgress(): number {
    return (100/30) * parseInt(this.countDown.toString())
  }

  toggleAppDrawer () {
    this.$store.dispatch(TOGGLE_APP_DRAWER)
  }

  closeMenu (): void {
    this.showMenu = false
  }

  mounted() {
  }
}
</script>

<style lang="stylus" scoped>
  .timer
    color red

  .app-title
    color var(--v-primary-base)

  .no-background-hover::before
    background-color: transparent !important

.toolbar-style
  >>> .v-toolbar__content{
    padding-right 0px
  }


</style>
